
import api from '@/api';

const namespaced = true;

const state = {
  makers: [],
  clients: [],
  company: {},
  rights: {},
  sites: [],
  currentAdminClient: {},
  isMaker: false,
  isAggregator: false,
  isRealEstate: false,
  isSelfMaker: false,
};

const mutations = {
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_COMPANY(state, company) {
    state.company = company;
    state.isMaker = Boolean(company.slug !== `` && company.isRoot);
    state.isAggregator = Boolean(company.slug !== `` && !company.isRoot);
    state.isRealEstate = Boolean(state.isAggregator && company.isRealEstate);
    state.isSelfMaker = Boolean(company.isSelfMaker === true);
    state.rights = company.rights || {};
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_CURRENT_ADMIN_CLIENT(state, adminClient) {
    state.currentAdminClient = adminClient;
  },
  SET_MAKERS(state, makers) {
    state.makers = makers;
  },
  ADD_CLIENT(state, client) {
    state.clients.push(client);
  },
  SAVE_CLIENT(state, saveClient) {
    let index = -1;
    state.clients.forEach((client, i) => {
      if (saveClient.id === client.id) {
        index = i;
      }
    });
    state.clients.splice(index, 1, saveClient);
  },
  DELETE_CLIENT(state, deletedClient) {
    let index = -1;
    state.clients.forEach((client, i) => {
      if (deletedClient.id === client.id) {
        index = i;
      }
    });
    state.clients.splice(index, 1);
  },
  ADD_MAKER(state, maker) {
    state.makers.push(maker);
  },
  SAVE_MAKER(state, saveMaker) {
    let index = -1;
    state.makers.forEach((maker, i) => {
      if (saveMaker.id === maker.id) {
        index = i;
      }
    });
    state.makers.splice(index, 1, saveMaker);
  },
};

const actions = {
  async fetchClients({ state, commit }, makerId = null) {
    makerId = makerId || state.company.id;
    const { data: clients } = await api.get(`/clients/maker/${makerId}?withNbUsers=1`);
    commit(`SET_CLIENTS`, clients);

    return clients;
  },
  async fetchListForMaker(store, makerId) {
    const { data: clients } = await api.get(`/clients/maker/${makerId}?withNbUsers=1`);

    return clients;
  },
  async fetchCompany({ state, commit, rootState }, force = false) {
    let companyWithNbUsers = state.company;
    if (!companyWithNbUsers || !companyWithNbUsers.id || force) {
      const { data: company } = await api.get(`/clients/slugged`);
      companyWithNbUsers = {
        ...company,
        nbUsers: rootState[`model/user`].users.length,
      };
      commit(`SET_COMPANY`, companyWithNbUsers);
    }
    return companyWithNbUsers;
  },
  async fetchSites({ commit, rootState }, clientId) {
    // const { data: sites } = await api.get(`/sites/client/${rootState[`model/client`].company.id}`);
    // const { data: sites } = await api.get(`/sites/client/${rootState[`model/user`].me.client.id}`);
    clientId = clientId || rootState[`model/user`].me.client.id;
    const { data: sites } = await api.get(`/sites/client/${clientId}`);
    commit(`SET_SITES`, sites);
    return sites;
  },
  async fetchCurrentAdminClient({ commit }, clientId) {
    const { data: client } = await api.get(`/clients/${clientId}`);
    commit(`SET_CURRENT_ADMIN_CLIENT`, client);
    return client;
  },
  async addClient({ state, commit }, client) {
    const { data: newClient } = await api.post(`/clients/maker/${state.company.id}`, client);
    commit(`ADD_CLIENT`, newClient);
    return newClient;
  },
  async saveClient({ state, commit }, client) {
    const { data: saveClient } = await api.put(`/clients/maker/${state.company.id}`, client);
    commit(`SAVE_CLIENT`, saveClient);
    return saveClient;
  },
  async deleteClient({ state, commit }, client) {
    try {
      await api.delete(`/clients/${client.id}/maker/${state.company.id}`);
      commit(`DELETE_CLIENT`, client);

      return true;
    } catch (e) {
      return false;
    }
  },
  async addMakerForCompany({ commit }, maker) {
    const { data: newMaker } = await api.post(`/makers/client/${maker.companyId}`, maker);
    commit(`ADD_MAKER`, newMaker);
    return newMaker;
  },
  async addAggregator(store, aggregator) {
    const { data: newAggregator } = await api.post(`/aggregators`, aggregator);

    return newAggregator;
  },
  async addMaker(store, maker) {
    const { data: newMaker } = await api.post(`/makers`, maker);

    return newMaker;
  },
  async saveMaker({ state, commit }, maker) {
    const { data: saveMaker } = await api.put(`/makers/client/${state.company.id}`, maker);
    commit(`SAVE_MAKER`, saveMaker);
    return saveMaker;
  },
  updateLogo({ state }, { clientId, logo }) {
    clientId = clientId || state.company.id;

    return api.post(`/clients/${clientId}/logo`, logo);
  },
};

const getters = {
  isIndeegoAdminApp: state => state.company?.slug === `admin`,
  getPlanRight: state => right => state.company?.planRights[right],
};

export default {
  namespaced, state, mutations, actions, getters,
};
